module.exports = __webpack_public_path__ + "img/option.9bc94136.svg";